/*
 * @Author: Code-HHX
 * @Date: 2021-12-10 11:07:06
 * @LastEditors: Code-HHX
 * @LastEditTime: 2021-12-16 15:35:45
 * @Description: 
 */
let baseUrl = process.env.VUE_APP_BASE_API
export default baseUrl
